import { render } from "./EditPayment.vue?vue&type=template&id=8d3b9b82&ts=true"
import script from "./EditPayment.vue?vue&type=script&lang=ts"
export * from "./EditPayment.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__